import styled, { keyframes } from 'styled-components';

export const ProgressBarTrack = styled.div`
  width: 100%;
  height: 5px;
  border-radius: 999px;
  background-color: #d9edf8;
  overflow: hidden;
`;

const progressStripeAnimation = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 20px 0;
  }
`;

export const ProgressBarFill = styled.div`
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background-image: linear-gradient(
    135deg,
    ${({ theme }) => theme.primaryFrontColor} 25%,
    ${({ theme }) => theme.primaryBackColorLight} 25%,
    ${({ theme }) => theme.primaryBackColorLight} 50%,
    ${({ theme }) => theme.primaryFrontColor} 50%,
    ${({ theme }) => theme.primaryFrontColor} 75%,
    ${({ theme }) => theme.primaryBackColorLight} 75%,
    ${({ theme }) => theme.primaryBackColorLight} 100%
  );
  background-size: 20px 20px;
  transition: width 0.25s ease-in-out;
  animation: ${progressStripeAnimation} 0.8s linear infinite;
`;
